import { useEffect } from "react"

import { useNavigate } from "react-router-dom"

import APP_BACKGROUND from "@assets/vertesia-background.png"
import APP_LOGO from "@assets/nfwf-logo.png"

import { EnterpriseSignInButton } from "@components/auth/EnterpriseSignInButton"

import { handleGithubSignIn } from "@plugins/auth/github"
import { handleGoogleSignIn } from "@plugins/auth/google"
import { handleMicrosoftSignIn } from "@plugins/auth/microsoft"
import { useUserSession } from "@plugins/session/UserSession"

import { Button } from "@ui/button"

export function SignInPage() {
    const { isLoading, user } = useUserSession()
    const navigate = useNavigate()

    useEffect(() => {
        if (!isLoading && user) {
            navigate("/")
        }
    }, [user, isLoading, navigate])

    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-svh">
                <div className="flex flex-col gap-2 text-center">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
                    <p className="text-sm text-muted-foreground">Loading NFWF Project...</p>
                </div>
            </div>
        )
    }

    if (user) {
        return null
    }

    const handleNavigateToPrivacy = () => {
        window.open("https://vertesiahq.com/privacy", "_blank")
    }

    const handleNavigateToTerms = () => {
        window.open("https://vertesiahq.com/terms", "_blank")
    }

    return (
        <div className="grid min-h-svh lg:grid-cols-2">
            <div className="flex flex-col gap-4 p-6 md:p-10">
                <div className="flex justify-center gap-2 md:justify-start">
                    <a href="#" className="flex items-center gap-2 font-medium">
                        <img src={APP_LOGO} alt="Vertesia logo" className="w-[100px]" />
                    </a>
                </div>
                <div className="flex flex-1 flex-col items-center justify-center">
                    <div className="my-4">
                        <h2 className="text-2xl font-bold text-center">Log in to your account</h2>
                    </div>
                    <div className="flex items-center flex-col">
                        <div className="flex flex-col gap-2 py-4 w-72">
                            <Button variant="outline" className="w-full" onClick={handleGoogleSignIn}>
                                <img src="https://www.svgrepo.com/show/475656/google-color.svg" alt="google logo" className="mr-2 h-4 w-4" loading="lazy" />
                                Login with Google
                            </Button>
                            <Button variant="outline" className="w-full" onClick={handleGithubSignIn}>
                                <img src="https://www.svgrepo.com/show/503359/github.svg" alt="github logo" className="mr-2 h-4 w-4" loading="lazy" />
                                Login with Github
                            </Button>
                            <Button variant="outline" className="w-full" onClick={handleMicrosoftSignIn}>
                                <img src="https://learn.microsoft.com/en-us/entra/identity-platform/media/howto-add-branding-in-apps/ms-symbollockup_mssymbol_19.svg" alt="microsoft logo" className="mr-2 h-4 w-4" loading="lazy" />
                                Login with Microsoft
                            </Button>
                        </div>
                        <div className="flex items-center flex-row w-72 text-accent-foreground">
                            <hr className="w-full" />
                            <p className="px-2 text-xs">OR</p>
                            <hr className="w-full" />
                        </div>
                        <div className="py-4 w-72">
                            <EnterpriseSignInButton />
                        </div>
                        <div className="w-72 flex justify-between">
                            <Button onClick={handleNavigateToPrivacy} variant="link" className="underline hover:opacity-40">
                                Privacy Policy
                            </Button>
                            <Button onClick={handleNavigateToTerms} variant="link" className="underline hover:opacity-40">
                                Terms of Service
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="relative hidden bg-muted lg:block">
                <img src={APP_BACKGROUND} alt="Vertesia Background" className="absolute inset-0 h-full w-full object-cover dark:brightness-[0.2] dark:grayscale" />
            </div>
        </div>
    )
}
